
import { get } from 'object-path';
export default {
  model: {
    prop: 'selected',
    event: 'update:selected'
  },

  props: {
    selected: {
      type: [Array, Boolean],
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: undefined
    },

    overline: {
      type: String,
      default: ''
    },

    caption: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    },

    truncateDescription: {
      type: Boolean,
      default: false
    },

    value: {
      type: null,
      default: undefined
    },

    field: {
      type: String,
      default: undefined
    },

    tag: {
      type: String,
      default: 'li'
    }
  },

  computed: {
    hasCheckbox () {
      return Array.isArray(this.selected) || 'update:selected' in this.$listeners;
    },

    list () {
      let parent = this.$parent;
      while (parent.$options._componentTag !== 'altura-list' && parent) { parent = parent.$parent; }

      if (!parent) {
        throw new Error('altura-list-item not part of altura-list.');
      }
      return parent;
    },

    isSelected: {
      get () {
        if (Array.isArray(this.selected)) {
          return this.selected.includes(this.key);
        }

        return this.selected;
      },
      set () {
        if (!this.hasCheckbox || typeof this.selected === 'boolean') {
          this.$emit('update:selected', !this.selected);
          return;
        }

        const index = this.selected.indexOf(this.key);
        if (index >= 0) {
          this.$emit('update:selected', this.selected.filter(x => x !== this.key));
        } else {
          this.$emit('update:selected', [...this.selected, this.key]);
        }
      }
    },

    key () {
      if (!this.field) { return this.value; }

      return get(this.value, this.field);
    }
  },

  mounted () {
    if (process.env.NODE_ENV !== 'production') {
      if (!this.field && Array.isArray(this.selected) && typeof this.value === 'object') {
      // eslint-disable-next-line no-console
        console.warn('[altura-list-item] The prop \'field\' is required when \'value\' is type \'Object\'.');
      }
    }
  },

  methods: {
    click () {
      if (this.hasCheckbox) {
        this.isSelected = !this.isSelected;
        return;
      }

      this.$emit('click');
    },

    focusNext () {
      this.list.selectNext(this.$el);
    },

    focusPrevious () {
      this.list.selectPrevious(this.$el);
    },

    getField (option) {
      if (!this.field) { return option; }

      return get(option, this.field);
    }
  }
};
